import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';
import dataLayer from '../tracking/dataLayer';

class Faq extends Controller {
  onQuestionClick(event) {
    const isOpen = event.currentTarget.getAttribute('aria-expanded') === 'true';

    this.closeOpenQuestions();

    if (!isOpen) {
      this.toggleQuestion(event.currentTarget, true);
    }
  }

  closeOpenQuestions() {
    const openQuestions = toArray(this.element.querySelectorAll('button[aria-expanded="true"]'));

    openQuestions.forEach((openQuestion) => {
      this.toggleQuestion(openQuestion, false);
    });
  }

  toggleQuestion(element, forceState = null) {
    const answerElement = this.answerElementForToggle(element);

    const isOpen = element.getAttribute('aria-expanded') === 'true';

    const state = forceState !== null ? forceState : !isOpen;

    if (state) {
      dataLayer.event('faq', 'open', element.textContent.trim());
    }

    element.setAttribute('aria-expanded', state ? 'true' : 'false');
    answerElement.setAttribute('aria-hidden', state ? 'false' : 'true');
  }

  // eslint-disable-next-line class-methods-use-this
  answerElementForToggle(element) {
    const id = element.getAttribute('aria-controls');
    return document.getElementById(id);
  }
}

export default Faq;
